import { useQuery, UseQueryResult } from '@tanstack/react-query';

import {
  TeamBlockers,
  fetchAllTeamsBlockers,
} from '../../../services/dashboardBlockers';
import { TeamIdentity } from '../../../types';

/**
 * Hook to fetch blockers for all teams
 * @param teams The list of teams to fetch blockers for
 * @returns Query result with teams and their blockers
 */
export function useTeamBlockers(
  teams: TeamIdentity[],
): UseQueryResult<TeamBlockers[], Error> {
  return useQuery<TeamBlockers[], Error>({
    queryKey: ['teamBlockers', teams],
    queryFn: () => fetchAllTeamsBlockers(teams),
    enabled: teams.length > 0,
  });
}
